export default function guestlistFieldValueTransformer(value, fieldDefinition, $injector) {
    const translateService = $injector.get('$translate'),
        filter = $injector.get('$filter'),
        rootScope = $injector.get('$rootScope');

    switch (fieldDefinition.type) {
        case 'integer':
            const int = parseInt(value);

            return (_.isInteger(int) ? int : 0) + '';
        case 'decimal':
        case 'float':
            const float = parseFloat(value);

            return _.isNumber(float) ? float.toFixed(2) : '0.00';
        case 'boolean':
        case 'bool':
            return translateService.instant(`general.verbs.${value ? 'yes' : 'no'}`);
        case 'date':
            if (!value) {
                return '';
            }

            return filter('date')(value, rootScope.globalDateFormats.date);
        case 'datetime':
            if (!value) {
                return '';
            }

            return filter('date')(value, rootScope.globalDateFormats.dateTime);
        case 'image':
        case 'file':
            if (!value) {
                return '';
            }

            return `<a class="button" href="${value.url}" download="value.name"><i class="fal fa-file-download"></i>&nbsp;${value.name}</a>`;
        case 'array_of_strings':
            return _.isArray(value) ? value.join(', ') : '';
        case 'html':
            return value + '';
        case 'color-codes':
            const activeColor = _.get(fieldDefinition.enum, value, null);
            if (!activeColor) {
                return '';
            }
            return $injector.get('$sce').trustAsHtml(`<span class="color-badge-old" style="background-color: ${activeColor.color_code}"></span>&nbsp;${angular.element('<pre/>').text(activeColor.label).html()}`)
        default:
            return filter('nl2br')(angular.element('<pre/>').text(value).html());
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/guestlists/helpers/guestlist-field-value-transformer.js